// extracted by mini-css-extract-plugin
export var palette = "'../../theme/palette.module.css'";
export var accent = "#3D5CFF";
export var btn = "style-module--btn--6Neyn";